import React from 'react';
import AbstractView from '../../src/components/_views/AbstractView';
import {IReduxUserState} from '../../src/@interfaces';
import Translate from '../../src/components/Translate/Translate';
import ErrorPageLayout from '../../src/components/_layouts/ErrorPageLayout/ErrorPageLayout';

export default class Error403 extends AbstractView<IReduxUserState> {
    static layout = ErrorPageLayout;
    protected static pageTitle = 'Errors.access_denied';

    protected renderContent(): React.ReactNode {
        return <Translate message="Errors.access_denied"/>;
    }
}
